import { Card } from '../ui/card';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Send } from 'lucide-react';

export default function StaffChatTab({ user, chatMessages, newMessage, setNewMessage, onSendMessage }) {
  return (
    <Card className="bg-zinc-900 border-zinc-700 p-6 flex flex-col h-[600px]">
      <h3 className="text-lg font-bold text-white mb-4">Crew Chat</h3>
      <div className="flex-1 overflow-y-auto space-y-4 mb-4 pr-2">
        {chatMessages.length === 0 ? (
          <p className="text-zinc-500 text-center py-8">No messages yet. Start the conversation!</p>
        ) : (
          chatMessages.map((msg) => (
            <div
              key={msg.message_id}
              className={`flex flex-col ${msg.sender_id === user.user_id ? 'items-end' : 'items-start'}`}
            >
              <div className="flex items-baseline space-x-2">
                {msg.sender_id !== user.user_id && (
                  <span className="text-xs text-zinc-400 mb-1">
                    {msg.sender_name} ({msg.sender_role})
                  </span>
                )}
              </div>
              <div
                className={`p-3 rounded-lg max-w-[80%] ${
                  msg.sender_id === user.user_id
                    ? 'bg-[#FFD60A] text-black rounded-tr-none'
                    : 'bg-zinc-800 text-white rounded-tl-none border border-zinc-700'
                }`}
              >
                <p className="text-sm">{msg.content}</p>
              </div>
              <span className="text-[10px] text-zinc-500 mt-1">
                {new Date(msg.created_at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
              </span>
            </div>
          ))
        )}
      </div>
      <form onSubmit={onSendMessage} className="flex gap-2 pt-4 border-t border-zinc-800">
        <Input
          value={newMessage}
          onChange={(e) => setNewMessage(e.target.value)}
          placeholder="Type a message to the crew..."
          className="bg-zinc-800 border-zinc-700 text-white flex-1"
          data-testid="staff-chat-input"
        />
        <Button type="submit" className="bg-[#FFD60A] text-black hover:bg-[#EAB308]" data-testid="staff-chat-send">
          <Send className="h-4 w-4" />
        </Button>
      </form>
    </Card>
  );
}
